// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"ModalFooter_modalFooter__3EZYF","modalFooterFlexLayout":"ModalFooter_modalFooterFlexLayout__1KhG_"};